import type { ManualAccessorial } from '@/api/useFreight/types'
import { AccessorialForm } from '@/components/Freight/FreightLineItems/components/AddFreightLineItem/components/AccessorialForm'
import { getAccessorialOptions } from '@/components/Freight/FreightLineItems/components/AddFreightLineItem/utils'
import { useWizardMaster } from '@/components/OrderWizard/Contexts/WizardMasterContext'
import { Popover } from 'antd'
import { FormInstance } from 'antd/lib'
import { useMemo, useState } from 'react'
import { getLocationsFromOrder } from './utils'

type AddAccessorialPopoverProps = {
  children: React.ReactNode
  order: Gravitate.Order
  form: FormInstance
  accessorialOptions: ManualAccessorial[]
  isAccessorialMutationPending: boolean
  handleAdd: () => void
}

export function AddAccessorialPopover({
  children,
  order,
  form,
  accessorialOptions,
  isAccessorialMutationPending,
  handleAdd,
}: AddAccessorialPopoverProps) {
  const [open, setOpen] = useState(false)
  function handleCancel() {
    form.resetFields()
    setOpen(false)
  }

  function handleSubmit() {
    handleAdd()
    handleCancel()
  }
  const locationOptions = useMemo(() => getLocationsFromOrder(order), [order])

  return (
    <Popover
      title='Add Manual Accessorial'
      trigger='click'
      open={open}
      onOpenChange={(visible) => setOpen(visible)}
      destroyTooltipOnHide
      styles={{ root: { width: 400 } }}
      content={
        <AccessorialForm
          form={form}
          accessorialOptions={getAccessorialOptions(accessorialOptions)}
          isAccessorialMutationPending={isAccessorialMutationPending}
          onFinish={handleSubmit}
          onReset={handleCancel}
          showRateAndTotal={false}
          terminalOptions={locationOptions}
          storeOptions={[]}
          groupLocations={false}
        />
      }
    >
      {children}
    </Popover>
  )
}
